var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-group info-icon"},[_vm._v("\n   "),_c('span',{on:{"click":function($event){_vm.notify()}}},[_c('md-icon',[_vm._v("info")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }